<ion-buttons>
  <ft-toggle-button *ngFor="let button of groupButtons.buttons" [(value)]="button.value" [fillStyle]="getButtonStyle()" [size]="groupButtons.style && groupButtons.style.fontSize"
    (valueChange)="onValueChange($event)" [ngStyle]="getButtonWidth()">
    {{button.title}}
  </ft-toggle-button>
</ion-buttons>